import { ReadPayroll } from "@/types/payroll";
import { Row } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { EnumFilter } from "@/components/data-table/components/EnumFilter";
import { PROJECT_DEPENDS_ON } from "@/schemas/commonFields/projectDependsOn";
import { PAYROLL_STATUS, PAYROLL_VERSION } from "@/schemas/payroll";

export const usePayrollsColumnOverrides = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      project_depends_on: {
        id: "project_depends_on",
        cell: ({ row }: { row: Row<ReadPayroll> }) =>
          t(
            `projectDependsOn.${row.original.project_depends_on}`,
            row.original.project_depends_on,
          ),
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: PROJECT_DEPENDS_ON,
              translationKey: "projectDependsOn",
            },
          },
        },
      },
      payroll_status: {
        id: "payroll_status",
        cell: ({ row }: { row: Row<ReadPayroll> }) =>
          t(
            `payrolls.enum.payroll_status.${row.original.payroll_status}`,
            row.original.payroll_status,
          ),
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: PAYROLL_STATUS,
              translationKey: "payrolls.enum.payroll_status",
            },
          },
        },
      },
      payroll_version: {
        id: "payroll_version",
        cell: ({ row }: { row: Row<ReadPayroll> }) =>
          t(
            `payrolls.enum.payroll_version.${row.original.payroll_version}`,
            row.original.payroll_version,
          ),
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: PAYROLL_VERSION,
              translationKey: "payrolls.enum.payroll_version",
            },
          },
        },
      },
      split: {
        id: "split",
        cell: ({ row }: { row: Row<ReadPayroll> }) =>
          t(row.original.split ? "common.yes" : "common.no"),
      },
    }),
    [t],
  );
};
